import { createFileRoute } from "@tanstack/react-router";
import { ComplianceNotice } from "@/components/ComplianceNotice";

export const Route = createFileRoute("/rb-disc")({
  component: () => (
    <main className="mx-auto w-full max-w-2xl px-4 py-8">
      <ComplianceNotice variant="board" />
    </main>
  ),
});
